// ============================================================
// CLUBHUB – Rechtswerte (Grenzen, Pauschalen, Fristen)
// ============================================================
// Eine Quelle fuer alle Zahlen, die aus Gesetzen, Verordnungen
// oder Regelwerken kommen. Wer eine Freigrenze, eine Pauschale
// oder eine Frist braucht, liest sie HIER ueber `RW.…` — nicht
// als Konstante im eigenen Modul. Ein Gesetzesupdate ist dann
// eine neue Zeile mit `gueltigAb`, kein Suchen im Code.
//
//   import { RW, wert } from "@/lib/rechtswerte";
//   const tage = wert(RW.SEPA_VORABANKUENDIGUNG_TAGE);
//   const pauschale = wert(RW.STEUER_UEBUNGSLEITERPAUSCHALE_EUR, "2025-12-31"); // 3000
//
// Regeln:
//   — Werte nie ueberschreiben. Aendert sich ein Wert, endet die
//     alte Zeile (`gueltigBis`) und eine neue beginnt. Abrechnungen
//     fuer Vorjahre brauchen den alten Wert.
//   — In `RECHTSWERTE` steht nur Geltendes und Beschlossenes. Was
//     erst geplant, verschoben oder anhaengig ist, steht in
//     `VORHABEN` und wirkt nicht auf Berechnungen.
//   — Jede Zeile traegt Rechtsgrundlage, Quelle (URL) und das Datum,
//     an dem jemand die Quelle gelesen hat (`geprueft`). Der Test
//     daneben verlangt beides.
//   — `status` beschreibt die Rechtslage am Pruefdatum fuer den
//     Zeitraum der Zeile: GILT (in Kraft bzw. galt in dem Zeitraum),
//     BESCHLOSSEN (verkuendet, beginnt spaeter), EMPFEHLUNG (Praxis
//     aus Vereinbarungen, kein Gesetz).
//   — clubhub zeigt diese Werte als Hilfsmittel. Es ersetzt keine
//     Steuer- oder Rechtsberatung.
//
// Letzte Durchsicht: 23.10.2026 (OPS-Task task_aefaad55ddd87311),
// alle Werte am Gesetzestext bzw. an der genannten Quelle gelesen.
// Naechste Durchsicht: 15.01.2027 (`faelligeVorhaben`).
// ============================================================

/** Stabile Schluessel. Module greifen nur hierueber zu. */
export const RW = {
  // Gemeinnuetzigkeit und Ertragsteuern
  STEUER_FREIGRENZE_WGB_EUR: "steuer.freigrenze_wgb",
  STEUER_ZWECKBETRIEB_SPORT_EUR: "steuer.zweckbetrieb_sport",
  STEUER_ZEITNAHE_MITTELVERWENDUNG_GRENZE_EUR: "steuer.zeitnahe_mittelverwendung_grenze",
  STEUER_FREIBETRAG_KST_EUR: "steuer.freibetrag_kst",
  STEUER_UEBUNGSLEITERPAUSCHALE_EUR: "steuer.uebungsleiterpauschale",
  STEUER_EHRENAMTSPAUSCHALE_EUR: "steuer.ehrenamtspauschale",
  HAFTUNG_VERGUETUNGSGRENZE_EUR: "haftung.verguetungsgrenze",
  // Umsatzsteuer
  UST_KLEINUNTERNEHMER_VORJAHR_EUR: "ust.kleinunternehmer_vorjahr",
  UST_KLEINUNTERNEHMER_LAUFEND_EUR: "ust.kleinunternehmer_laufend",
  UST_PAUSCHALER_VORSTEUERABZUG_GRENZE_EUR: "ust.pauschaler_vorsteuerabzug_grenze",
  UST_PAUSCHALER_VORSTEUERABZUG_SATZ_PROZENT: "ust.pauschaler_vorsteuerabzug_satz",
  UST_SATZ_SPEISEN_PROZENT: "ust.satz_speisen",
  // Zuwendungsbestaetigungen
  SPENDEN_VEREINFACHTER_NACHWEIS_EUR: "spenden.vereinfachter_nachweis",
  SPENDEN_ALTER_FREISTELLUNGSBESCHEID_JAHRE: "spenden.alter_freistellungsbescheid",
  SPENDEN_ALTER_FESTSTELLUNG_60A_JAHRE: "spenden.alter_feststellung_60a",
  SPENDEN_HAFTUNGSSATZ_PROZENT: "spenden.haftungssatz",
  // E-Rechnung
  ERECHNUNG_EMPFANG_PFLICHT_AB_DATUM: "erechnung.empfang_pflicht_ab",
  ERECHNUNG_UEBERGANG_2027_GRENZE_EUR: "erechnung.uebergang_2027_grenze",
  ERECHNUNG_VERSAND_PFLICHT_ALLE_AB_DATUM: "erechnung.versand_pflicht_alle_ab",
  ERECHNUNG_KLEINBETRAG_EUR: "erechnung.kleinbetrag",
  // Aufbewahrung und Kasse
  AUFBEWAHRUNG_BUCHUNGSBELEGE_JAHRE: "aufbewahrung.buchungsbelege",
  AUFBEWAHRUNG_BUECHER_JAHRE: "aufbewahrung.buecher",
  AUFBEWAHRUNG_SONSTIGE_JAHRE: "aufbewahrung.sonstige",
  KASSE_TSE_MELDEFRIST_MONATE: "kasse.tse_meldefrist",
  // Arbeit und Minijob
  ARBEIT_MINDESTLOHN_EUR: "arbeit.mindestlohn",
  ARBEIT_MINIJOB_GRENZE_EUR: "arbeit.minijob_grenze",
  // Datenschutz
  DSGVO_DSB_SCHWELLE_PERSONEN: "dsgvo.dsb_schwelle",
  DSGVO_AUSKUNFT_FRIST_MONATE: "dsgvo.auskunft_frist",
  DSGVO_PANNE_MELDEFRIST_STUNDEN: "dsgvo.panne_meldefrist",
  // Kinder- und Jugendschutz
  KINDERSCHUTZ_FZ_LOESCHFRIST_MONATE: "kinderschutz.fz_loeschfrist",
  KINDERSCHUTZ_FZ_HOECHSTALTER_MONATE: "kinderschutz.fz_hoechstalter",
  KINDERSCHUTZ_FZ_WIEDERVORLAGE_JAHRE: "kinderschutz.fz_wiedervorlage",
  KINDERSCHUTZ_FZ_DIGITAL_AB_DATUM: "kinderschutz.fz_digital_ab",
  // SEPA
  SEPA_VORABANKUENDIGUNG_TAGE: "sepa.vorabankuendigung",
  SEPA_RUECKGABE_AUTORISIERT_WOCHEN: "sepa.rueckgabe_autorisiert",
  SEPA_RUECKGABE_OHNE_MANDAT_MONATE: "sepa.rueckgabe_ohne_mandat",
  SEPA_MANDAT_VERFALL_MONATE: "sepa.mandat_verfall",
  SEPA_MANDAT_AUFBEWAHRUNG_MONATE: "sepa.mandat_aufbewahrung",
  SEPA_EMPFAENGERPRUEFUNG_AB_DATUM: "sepa.empfaengerpruefung_ab",
  // Vereinsrecht und Barrierefreiheit
  VEREIN_SATZUNGSAENDERUNG_MEHRHEIT_PROZENT: "verein.satzungsaenderung_mehrheit",
  BFSG_AB_DATUM: "barrierefreiheit.bfsg_ab",
} as const;

export type RwSchluessel = (typeof RW)[keyof typeof RW];

export type RechtswertStatus = "GILT" | "BESCHLOSSEN" | "EMPFEHLUNG";

export type Einheit =
  | "EUR"
  | "PROZENT"
  | "STUNDEN"
  | "TAGE"
  | "WOCHEN"
  | "MONATE"
  | "JAHRE"
  | "PERSONEN"
  | "DATUM";

export type Land = "DE" | "AT" | "CH";

export type Rechtswert = {
  schluessel: RwSchluessel;
  bezeichnung: string;
  /** Zahl in `einheit`; bei DATUM ein ISO-Datum (JJJJ-MM-TT). */
  wert: number | string;
  einheit: Einheit;
  land: Land;
  /** Erster Geltungstag (ISO). Fehlt er, gilt der Wert seit laengerem. */
  gueltigAb?: string;
  /** Letzter Geltungstag (ISO), wenn ein Nachfolger feststeht. */
  gueltigBis?: string;
  status: RechtswertStatus;
  rechtsgrundlage: string;
  /** URL der gelesenen Quelle, moeglichst der Gesetzestext. */
  quelle: string;
  /** Wann die Quelle zuletzt gelesen wurde (ISO). */
  geprueft: string;
  hinweis?: string;
};

export type VorhabenStatus =
  | "KABINETT"
  | "PARLAMENT"
  | "BUNDESRAT"
  | "VERHANDLUNG"
  | "ANGEKUENDIGT"
  | "VERSCHOBEN"
  | "ANHAENGIG";

/** Eine Aenderung, die noch nicht gilt. Wirkt nicht auf Berechnungen. */
export type Vorhaben = {
  id: string;
  titel: string;
  status: VorhabenStatus;
  /** Was am Pruefdatum feststand. */
  stand: string;
  /** Welche Rechtswerte sich aendern wuerden. */
  betrifft: RwSchluessel[];
  /** Was clubhub tun muss, wenn es kommt. */
  folgen: string;
  quelle: string;
  geprueft: string;
  /** Naechster Pruefzeitpunkt (ISO). */
  wiedervorlage: string;
};

const GEPRUEFT = "2026-10-23";
const STAENDG_2025 = "Steueränderungsgesetz 2025 (BGBl. 2025 I Nr. 363)";
const LSB_SACHSEN_2026 =
  "https://www.sport-fuer-sachsen.de/files/user_upload/03_Dokumentenarchiv_LSB/Sport_und_Recht/Neuerungen_2026_02.pdf";
const GII = "https://www.gesetze-im-internet.de";
const SEPA_FACTSHEET =
  "https://www.vrbank-ke-oa.de/content/dam/f0283-0/cloud-transfer/Homepage/OnlineBanking/Services/Download-und-Demos/Sepa-Factsheet.pdf";

export const RECHTSWERTE: readonly Rechtswert[] = [
  // ── Gemeinnuetzigkeit und Ertragsteuern ───────────────────
  {
    schluessel: RW.STEUER_FREIGRENZE_WGB_EUR,
    bezeichnung: "Freigrenze wirtschaftlicher Geschäftsbetrieb (Einnahmen inkl. USt je Jahr)",
    wert: 45_000,
    einheit: "EUR",
    land: "DE",
    gueltigBis: "2025-12-31",
    status: "GILT",
    rechtsgrundlage: "§ 64 Abs. 3 AO a. F.",
    quelle: LSB_SACHSEN_2026,
    geprueft: GEPRUEFT,
  },
  {
    schluessel: RW.STEUER_FREIGRENZE_WGB_EUR,
    bezeichnung: "Freigrenze wirtschaftlicher Geschäftsbetrieb (Einnahmen inkl. USt je Jahr)",
    wert: 50_000,
    einheit: "EUR",
    land: "DE",
    gueltigAb: "2026-01-01",
    status: "GILT",
    rechtsgrundlage: `§ 64 Abs. 3 S. 1 AO, ${STAENDG_2025}`,
    quelle: `${GII}/ao_1977/__64.html`,
    geprueft: GEPRUEFT,
    hinweis:
      "Bleiben die Einnahmen darunter, ist für Körperschaft- und Gewerbesteuer die Prüfung der Zweckbetriebe (§§ 65 bis 68 AO) nicht mehr erforderlich (§ 64 Abs. 3 S. 2 AO). Für die Umsatzsteuer bleibt die Zuordnung nötig, die Sphäre bleibt deshalb Pflichtfeld je Buchung.",
  },
  {
    schluessel: RW.STEUER_ZWECKBETRIEB_SPORT_EUR,
    bezeichnung: "Sportveranstaltungen sind Zweckbetrieb bis Einnahmen inkl. USt je Jahr",
    wert: 45_000,
    einheit: "EUR",
    land: "DE",
    gueltigBis: "2025-12-31",
    status: "GILT",
    rechtsgrundlage: "§ 67a Abs. 1 S. 1 AO a. F.",
    quelle: LSB_SACHSEN_2026,
    geprueft: GEPRUEFT,
  },
  {
    schluessel: RW.STEUER_ZWECKBETRIEB_SPORT_EUR,
    bezeichnung: "Sportveranstaltungen sind Zweckbetrieb bis Einnahmen inkl. USt je Jahr",
    wert: 50_000,
    einheit: "EUR",
    land: "DE",
    gueltigAb: "2026-01-01",
    status: "GILT",
    rechtsgrundlage: `§ 67a Abs. 1 S. 1 AO, ${STAENDG_2025}`,
    quelle: `${GII}/ao_1977/__67a.html`,
    geprueft: GEPRUEFT,
  },
  {
    schluessel: RW.STEUER_ZEITNAHE_MITTELVERWENDUNG_GRENZE_EUR,
    bezeichnung: "Keine zeitnahe Mittelverwendung nötig bis jährliche Einnahmen",
    wert: 45_000,
    einheit: "EUR",
    land: "DE",
    gueltigBis: "2025-12-31",
    status: "GILT",
    rechtsgrundlage: "§ 55 Abs. 1 Nr. 5 S. 4 AO a. F.",
    quelle: LSB_SACHSEN_2026,
    geprueft: GEPRUEFT,
  },
  {
    schluessel: RW.STEUER_ZEITNAHE_MITTELVERWENDUNG_GRENZE_EUR,
    bezeichnung: "Keine zeitnahe Mittelverwendung nötig bis jährliche Einnahmen",
    wert: 100_000,
    einheit: "EUR",
    land: "DE",
    gueltigAb: "2026-01-01",
    status: "GILT",
    rechtsgrundlage: `§ 55 Abs. 1 Nr. 5 S. 4 AO, ${STAENDG_2025}`,
    quelle: `${GII}/ao_1977/__55.html`,
    geprueft: GEPRUEFT,
    hinweis: "Mittelverwendungsrechnung unterhalb der Grenze als freiwillig kennzeichnen.",
  },
  {
    schluessel: RW.STEUER_FREIBETRAG_KST_EUR,
    bezeichnung: "Freibetrag Körperschaftsteuer",
    wert: 5_000,
    einheit: "EUR",
    land: "DE",
    status: "GILT",
    rechtsgrundlage: "§ 24 KStG",
    quelle: `${GII}/kstg_1977/__24.html`,
    geprueft: GEPRUEFT,
    hinweis: "Höchstens in Höhe des Einkommens. Für die Gewerbesteuer gilt derselbe Betrag (§ 11 GewStG, nicht neu gelesen).",
  },
  {
    schluessel: RW.STEUER_UEBUNGSLEITERPAUSCHALE_EUR,
    bezeichnung: "Übungsleiterpauschale je Person und Jahr",
    wert: 3_000,
    einheit: "EUR",
    land: "DE",
    gueltigBis: "2025-12-31",
    status: "GILT",
    rechtsgrundlage: "§ 3 Nr. 26 EStG a. F.",
    quelle: LSB_SACHSEN_2026,
    geprueft: GEPRUEFT,
  },
  {
    schluessel: RW.STEUER_UEBUNGSLEITERPAUSCHALE_EUR,
    bezeichnung: "Übungsleiterpauschale je Person und Jahr",
    wert: 3_300,
    einheit: "EUR",
    land: "DE",
    gueltigAb: "2026-01-01",
    status: "GILT",
    rechtsgrundlage: `§ 3 Nr. 26 EStG, ${STAENDG_2025}`,
    quelle: LSB_SACHSEN_2026,
    geprueft: GEPRUEFT,
    hinweis:
      "Personenbezogen über alle Auftraggeber: Erklärung der Person zur anderweitigen Inanspruchnahme einholen. Mit Minijob zusammen 878 EUR im Monat (603 + 275, Stand 2026).",
  },
  {
    schluessel: RW.STEUER_EHRENAMTSPAUSCHALE_EUR,
    bezeichnung: "Ehrenamtspauschale je Person und Jahr",
    wert: 840,
    einheit: "EUR",
    land: "DE",
    gueltigBis: "2025-12-31",
    status: "GILT",
    rechtsgrundlage: "§ 3 Nr. 26a EStG a. F.",
    quelle: LSB_SACHSEN_2026,
    geprueft: GEPRUEFT,
  },
  {
    schluessel: RW.STEUER_EHRENAMTSPAUSCHALE_EUR,
    bezeichnung: "Ehrenamtspauschale je Person und Jahr",
    wert: 960,
    einheit: "EUR",
    land: "DE",
    gueltigAb: "2026-01-01",
    status: "GILT",
    rechtsgrundlage: `§ 3 Nr. 26a EStG, ${STAENDG_2025}`,
    quelle: LSB_SACHSEN_2026,
    geprueft: GEPRUEFT,
    hinweis:
      "Mit Minijob zusammen 683 EUR im Monat (603 + 80, Stand 2026). Vergütung an Vorstandsmitglieder nur, wenn die Satzung sie erlaubt (§ 27 Abs. 3 S. 2 BGB).",
  },
  {
    schluessel: RW.HAFTUNG_VERGUETUNGSGRENZE_EUR,
    bezeichnung: "Haftung nur bei Vorsatz und grober Fahrlässigkeit bis Vergütung je Jahr",
    wert: 840,
    einheit: "EUR",
    land: "DE",
    gueltigBis: "2025-12-31",
    status: "GILT",
    rechtsgrundlage: "§§ 31a, 31b BGB a. F.",
    quelle: LSB_SACHSEN_2026,
    geprueft: GEPRUEFT,
  },
  {
    schluessel: RW.HAFTUNG_VERGUETUNGSGRENZE_EUR,
    bezeichnung: "Haftung nur bei Vorsatz und grober Fahrlässigkeit bis Vergütung je Jahr",
    wert: 3_300,
    einheit: "EUR",
    land: "DE",
    gueltigAb: "2026-01-01",
    status: "GILT",
    rechtsgrundlage: "§§ 31a, 31b BGB",
    quelle: `${GII}/bgb/__31a.html`,
    geprueft: GEPRUEFT,
    hinweis: "Gilt für Organmitglieder, besondere Vertreter und ehrenamtlich tätige Mitglieder.",
  },
  // ── Umsatzsteuer ──────────────────────────────────────────
  {
    schluessel: RW.UST_KLEINUNTERNEHMER_VORJAHR_EUR,
    bezeichnung: "Kleinunternehmer: Gesamtumsatz im Vorjahr höchstens",
    wert: 25_000,
    einheit: "EUR",
    land: "DE",
    gueltigAb: "2025-01-01",
    status: "GILT",
    rechtsgrundlage: "§ 19 Abs. 1 UStG",
    quelle: `${GII}/ustg_1980/__19.html`,
    geprueft: GEPRUEFT,
    hinweis: "Echte Mitgliedsbeiträge sind nicht steuerbar und zählen nicht mit.",
  },
  {
    schluessel: RW.UST_KLEINUNTERNEHMER_LAUFEND_EUR,
    bezeichnung: "Kleinunternehmer: Gesamtumsatz im laufenden Jahr höchstens",
    wert: 100_000,
    einheit: "EUR",
    land: "DE",
    gueltigAb: "2025-01-01",
    status: "GILT",
    rechtsgrundlage: "§ 19 Abs. 1 UStG",
    quelle: `${GII}/ustg_1980/__19.html`,
    geprueft: GEPRUEFT,
    hinweis: "Wird die Grenze im laufenden Jahr überschritten, endet der Status ab dem Umsatz, der sie überschreitet.",
  },
  {
    schluessel: RW.UST_PAUSCHALER_VORSTEUERABZUG_GRENZE_EUR,
    bezeichnung: "Pauschaler Vorsteuerabzug nur bis steuerpflichtigem Vorjahresumsatz",
    wert: 50_000,
    einheit: "EUR",
    land: "DE",
    status: "GILT",
    rechtsgrundlage: "§ 23a Abs. 2 UStG",
    quelle: `${GII}/ustg_1980/__23a.html`,
    geprueft: GEPRUEFT,
    hinweis: "Wahlrecht bindet fünf Kalenderjahre (§ 23a Abs. 3 UStG).",
  },
  {
    schluessel: RW.UST_PAUSCHALER_VORSTEUERABZUG_SATZ_PROZENT,
    bezeichnung: "Pauschaler Vorsteuerabzug: Durchschnittssatz des steuerpflichtigen Umsatzes",
    wert: 7,
    einheit: "PROZENT",
    land: "DE",
    status: "GILT",
    rechtsgrundlage: "§ 23a Abs. 1 UStG",
    quelle: `${GII}/ustg_1980/__23a.html`,
    geprueft: GEPRUEFT,
  },
  {
    schluessel: RW.UST_SATZ_SPEISEN_PROZENT,
    bezeichnung: "Umsatzsteuersatz für Restaurant- und Verpflegungsdienstleistungen (ohne Getränke)",
    wert: 7,
    einheit: "PROZENT",
    land: "DE",
    gueltigAb: "2026-01-01",
    status: "GILT",
    rechtsgrundlage: `§ 12 Abs. 2 Nr. 15 UStG, ${STAENDG_2025}`,
    quelle: `${GII}/ustg_1980/__12.html`,
    geprueft: GEPRUEFT,
    hinweis: "Unbefristet. Getränke bleiben beim Regelsatz von 19 %.",
  },
  // ── Zuwendungsbestaetigungen ──────────────────────────────
  {
    schluessel: RW.SPENDEN_VEREINFACHTER_NACHWEIS_EUR,
    bezeichnung: "Vereinfachter Spendennachweis (Kontoauszug) bis je Zuwendung",
    wert: 300,
    einheit: "EUR",
    land: "DE",
    status: "GILT",
    rechtsgrundlage: "§ 50 Abs. 4 EStDV",
    quelle: `${GII}/estdv_1955/__50.html`,
    geprueft: GEPRUEFT,
    hinweis: "Nur mit vom Verein vorbereitetem Beleg: Zweck, Freistellung und Angabe Spende oder Mitgliedsbeitrag.",
  },
  {
    schluessel: RW.SPENDEN_ALTER_FREISTELLUNGSBESCHEID_JAHRE,
    bezeichnung: "Freistellungsbescheid bzw. Anlage zum KSt-Bescheid höchstens so alt",
    wert: 5,
    einheit: "JAHRE",
    land: "DE",
    status: "GILT",
    rechtsgrundlage: "§ 63 Abs. 5 S. 1 Nr. 1 AO",
    quelle: `${GII}/ao_1977/__63.html`,
    geprueft: GEPRUEFT,
    hinweis: "Taggenau ab Datum des Bescheids. Danach keine Zuwendungsbestätigungen mehr ausstellen.",
  },
  {
    schluessel: RW.SPENDEN_ALTER_FESTSTELLUNG_60A_JAHRE,
    bezeichnung: "Feststellung der Satzungsmäßigkeit (§ 60a AO) höchstens so viele Kalenderjahre alt",
    wert: 3,
    einheit: "JAHRE",
    land: "DE",
    status: "GILT",
    rechtsgrundlage: "§ 63 Abs. 5 S. 1 Nr. 2 AO",
    quelle: `${GII}/ao_1977/__63.html`,
    geprueft: GEPRUEFT,
    hinweis: "Nur solange noch kein Freistellungsbescheid erteilt ist.",
  },
  {
    schluessel: RW.SPENDEN_HAFTUNGSSATZ_PROZENT,
    bezeichnung: "Haftung für unrichtige Zuwendungsbestätigungen (Anteil der Zuwendung)",
    wert: 30,
    einheit: "PROZENT",
    land: "DE",
    status: "GILT",
    rechtsgrundlage: "§ 10b Abs. 4 S. 3 EStG",
    quelle: `${GII}/estg/__10b.html`,
    geprueft: GEPRUEFT,
    hinweis:
      "Mitgliedsbeiträge an Vereine, die Sport, Freizeitkultur, Heimatpflege oder Zwecke nach § 52 Abs. 2 S. 1 Nr. 23 AO fördern, sind nicht abziehbar (§ 10b Abs. 1 S. 8 EStG) und gehören nicht auf die Bestätigung.",
  },
  // ── E-Rechnung ────────────────────────────────────────────
  {
    schluessel: RW.ERECHNUNG_EMPFANG_PFLICHT_AB_DATUM,
    bezeichnung: "E-Rechnungen empfangen können (unternehmerischer Bereich)",
    wert: "2025-01-01",
    einheit: "DATUM",
    land: "DE",
    gueltigAb: "2025-01-01",
    status: "GILT",
    rechtsgrundlage: "§ 14 Abs. 1 UStG",
    quelle: `${GII}/ustg_1980/__14.html`,
    geprueft: GEPRUEFT,
    hinweis: "Nur Umsätze zwischen inländischen Unternehmern; Beiträge und Spenden sind nicht betroffen.",
  },
  {
    schluessel: RW.ERECHNUNG_UEBERGANG_2027_GRENZE_EUR,
    bezeichnung: "2027 noch Papier oder sonstige Rechnung erlaubt bis Vorjahres-Gesamtumsatz",
    wert: 800_000,
    einheit: "EUR",
    land: "DE",
    gueltigAb: "2027-01-01",
    gueltigBis: "2027-12-31",
    status: "BESCHLOSSEN",
    rechtsgrundlage: "§ 27 Abs. 38 Nr. 2 UStG",
    quelle: `${GII}/ustg_1980/__27.html`,
    geprueft: GEPRUEFT,
    hinweis: "2025 und 2026 gilt die Übergangsregel für alle, unabhängig vom Umsatz (§ 27 Abs. 38 Nr. 1 UStG).",
  },
  {
    schluessel: RW.ERECHNUNG_VERSAND_PFLICHT_ALLE_AB_DATUM,
    bezeichnung: "E-Rechnung im Versand Pflicht für alle Unternehmer",
    wert: "2028-01-01",
    einheit: "DATUM",
    land: "DE",
    gueltigAb: "2028-01-01",
    status: "BESCHLOSSEN",
    rechtsgrundlage: "§ 14 Abs. 1 UStG, Auslaufen von § 27 Abs. 38 UStG",
    quelle: `${GII}/ustg_1980/__27.html`,
    geprueft: GEPRUEFT,
    hinweis:
      "Ausnahmen: Kleinbetragsrechnungen, steuerfreie Umsätze nach § 4 Nr. 8 bis 29 UStG; Kleinunternehmer dürfen immer eine sonstige Rechnung ausstellen (§ 34a S. 4 UStDV).",
  },
  {
    schluessel: RW.ERECHNUNG_KLEINBETRAG_EUR,
    bezeichnung: "Kleinbetragsrechnung bis Gesamtbetrag (keine E-Rechnung nötig)",
    wert: 250,
    einheit: "EUR",
    land: "DE",
    status: "GILT",
    rechtsgrundlage: "§ 33 UStDV",
    quelle: `${GII}/ustdv_1980/__33.html`,
    geprueft: GEPRUEFT,
  },
  // ── Aufbewahrung und Kasse ────────────────────────────────
  {
    schluessel: RW.AUFBEWAHRUNG_BUCHUNGSBELEGE_JAHRE,
    bezeichnung: "Aufbewahrung Buchungsbelege",
    wert: 8,
    einheit: "JAHRE",
    land: "DE",
    gueltigAb: "2025-01-01",
    status: "GILT",
    rechtsgrundlage: "§ 147 Abs. 3 S. 1 AO (Viertes Bürokratieentlastungsgesetz)",
    quelle: `${GII}/ao_1977/__147.html`,
    geprueft: GEPRUEFT,
    hinweis:
      "Gilt auch für Belege, deren Frist am 01.01.2025 noch lief. Löschung nur als Vorschlag, nie automatisch.",
  },
  {
    schluessel: RW.AUFBEWAHRUNG_BUECHER_JAHRE,
    bezeichnung: "Aufbewahrung Bücher, Aufzeichnungen, Jahresabschlüsse",
    wert: 10,
    einheit: "JAHRE",
    land: "DE",
    status: "GILT",
    rechtsgrundlage: "§ 147 Abs. 3 S. 1 AO",
    quelle: `${GII}/ao_1977/__147.html`,
    geprueft: GEPRUEFT,
  },
  {
    schluessel: RW.AUFBEWAHRUNG_SONSTIGE_JAHRE,
    bezeichnung: "Aufbewahrung Geschäftsbriefe und sonstige Unterlagen",
    wert: 6,
    einheit: "JAHRE",
    land: "DE",
    status: "GILT",
    rechtsgrundlage: "§ 147 Abs. 3 S. 1 AO",
    quelle: `${GII}/ao_1977/__147.html`,
    geprueft: GEPRUEFT,
  },
  {
    schluessel: RW.KASSE_TSE_MELDEFRIST_MONATE,
    bezeichnung: "Elektronische Kasse beim Finanzamt melden innerhalb von",
    wert: 1,
    einheit: "MONATE",
    land: "DE",
    gueltigAb: "2025-01-01",
    status: "GILT",
    rechtsgrundlage: "§ 146a Abs. 4 S. 2 AO",
    quelle: `${GII}/ao_1977/__146a.html`,
    geprueft: GEPRUEFT,
    hinweis: "Nach Anschaffung und nach Außerbetriebnahme; betrifft Vereinsheim und Festkassen.",
  },
  // ── Arbeit und Minijob ────────────────────────────────────
  {
    schluessel: RW.ARBEIT_MINDESTLOHN_EUR,
    bezeichnung: "Gesetzlicher Mindestlohn je Stunde",
    wert: 12.82,
    einheit: "EUR",
    land: "DE",
    gueltigAb: "2025-01-01",
    gueltigBis: "2025-12-31",
    status: "GILT",
    rechtsgrundlage: "MiLoG, Vierte Mindestlohnanpassungsverordnung",
    quelle: LSB_SACHSEN_2026,
    geprueft: GEPRUEFT,
  },
  {
    schluessel: RW.ARBEIT_MINDESTLOHN_EUR,
    bezeichnung: "Gesetzlicher Mindestlohn je Stunde",
    wert: 13.9,
    einheit: "EUR",
    land: "DE",
    gueltigAb: "2026-01-01",
    gueltigBis: "2026-12-31",
    status: "GILT",
    rechtsgrundlage: "MiLoG, Fünfte Mindestlohnanpassungsverordnung (BGBl. 2025 I Nr. 268)",
    quelle: `${GII}/milov5/BJNR10C0A0025.html`,
    geprueft: GEPRUEFT,
  },
  {
    schluessel: RW.ARBEIT_MINDESTLOHN_EUR,
    bezeichnung: "Gesetzlicher Mindestlohn je Stunde",
    wert: 14.6,
    einheit: "EUR",
    land: "DE",
    gueltigAb: "2027-01-01",
    status: "BESCHLOSSEN",
    rechtsgrundlage: "MiLoG, Fünfte Mindestlohnanpassungsverordnung (BGBl. 2025 I Nr. 268)",
    quelle: `${GII}/milov5/BJNR10C0A0025.html`,
    geprueft: GEPRUEFT,
  },
  {
    schluessel: RW.ARBEIT_MINIJOB_GRENZE_EUR,
    bezeichnung: "Minijob-Grenze je Monat",
    wert: 556,
    einheit: "EUR",
    land: "DE",
    gueltigAb: "2025-01-01",
    gueltigBis: "2025-12-31",
    status: "GILT",
    rechtsgrundlage: "§ 8 Abs. 1a SGB IV",
    quelle: LSB_SACHSEN_2026,
    geprueft: GEPRUEFT,
  },
  {
    schluessel: RW.ARBEIT_MINIJOB_GRENZE_EUR,
    bezeichnung: "Minijob-Grenze je Monat",
    wert: 603,
    einheit: "EUR",
    land: "DE",
    gueltigAb: "2026-01-01",
    gueltigBis: "2026-12-31",
    status: "GILT",
    rechtsgrundlage: "§ 8 Abs. 1a SGB IV",
    quelle: LSB_SACHSEN_2026,
    geprueft: GEPRUEFT,
  },
  {
    schluessel: RW.ARBEIT_MINIJOB_GRENZE_EUR,
    bezeichnung: "Minijob-Grenze je Monat",
    wert: 633,
    einheit: "EUR",
    land: "DE",
    gueltigAb: "2027-01-01",
    status: "BESCHLOSSEN",
    rechtsgrundlage: "§ 8 Abs. 1a SGB IV",
    quelle: `${GII}/milov5/BJNR10C0A0025.html`,
    geprueft: GEPRUEFT,
    hinweis:
      "Abgeleitet: Mindestlohn 14,60 EUR × 130 ÷ 3, auf volle Euro aufgerundet (dieselbe Rechnung ergibt 556 für 2025 und 603 für 2026). Amtliche Bekanntgabe der Minijob-Zentrale abgleichen.",
  },
  // ── Datenschutz ───────────────────────────────────────────
  {
    schluessel: RW.DSGVO_DSB_SCHWELLE_PERSONEN,
    bezeichnung: "Datenschutzbeauftragter nötig ab Personen, die ständig automatisiert verarbeiten",
    wert: 20,
    einheit: "PERSONEN",
    land: "DE",
    status: "GILT",
    rechtsgrundlage: "§ 38 Abs. 1 BDSG",
    quelle: "https://www.buzer.de/38_BDSG.htm",
    geprueft: GEPRUEFT,
    hinweis: "In der Regel; Ehrenamtliche zählen mit. Enge Rollen halten die Zahl klein.",
  },
  {
    schluessel: RW.DSGVO_AUSKUNFT_FRIST_MONATE,
    bezeichnung: "Antwort auf Anträge der betroffenen Person (Auskunft, Löschung, Berichtigung) spätestens nach",
    wert: 1,
    einheit: "MONATE",
    land: "DE",
    status: "GILT",
    rechtsgrundlage: "Art. 12 Abs. 3 S. 1 DSGVO",
    quelle: "https://dsgvo-gesetz.de/art-12-dsgvo/",
    geprueft: GEPRUEFT,
    hinweis: "Ab Eingang des Antrags; Verlängerung um zwei Monate nur mit Begründung.",
  },
  {
    schluessel: RW.DSGVO_PANNE_MELDEFRIST_STUNDEN,
    bezeichnung: "Datenpanne an die Aufsichtsbehörde melden möglichst binnen",
    wert: 72,
    einheit: "STUNDEN",
    land: "DE",
    status: "GILT",
    rechtsgrundlage: "Art. 33 Abs. 1 S. 1 DSGVO",
    quelle: "https://dsgvo-gesetz.de/art-33-dsgvo/",
    geprueft: GEPRUEFT,
    hinweis: "Ab Kenntnis. Entfällt, wenn kein Risiko für die Betroffenen besteht; Verspätung begründen.",
  },
  // ── Kinder- und Jugendschutz ──────────────────────────────
  {
    schluessel: RW.KINDERSCHUTZ_FZ_LOESCHFRIST_MONATE,
    bezeichnung: "Vermerk zum Führungszeugnis löschen spätestens nach Ende der Tätigkeit",
    wert: 6,
    einheit: "MONATE",
    land: "DE",
    status: "GILT",
    rechtsgrundlage: "§ 72a Abs. 5 SGB VIII",
    quelle: `${GII}/sgb_8/__72a.html`,
    geprueft: GEPRUEFT,
    hinweis:
      "Speichern dürfen Vereine nur: dass Einsicht genommen wurde, das Datum des Zeugnisses und ob eine einschlägige Verurteilung vorliegt. Keine Kopie. Wird die Tätigkeit nicht aufgenommen: sofort löschen.",
  },
  {
    schluessel: RW.KINDERSCHUTZ_FZ_HOECHSTALTER_MONATE,
    bezeichnung: "Führungszeugnis bei Vorlage höchstens so alt",
    wert: 3,
    einheit: "MONATE",
    land: "DE",
    status: "EMPFEHLUNG",
    rechtsgrundlage: "Vereinbarungen nach § 72a Abs. 4 SGB VIII",
    quelle: "https://www.dsb.de/fileadmin/DSB.DE/PDF/PDF_2025/Leitfaden_Fuehrungszeugnisse_2025.pdf",
    geprueft: GEPRUEFT,
    hinweis: "Maßgeblich ist die Vereinbarung mit dem örtlichen Jugendamt.",
  },
  {
    schluessel: RW.KINDERSCHUTZ_FZ_WIEDERVORLAGE_JAHRE,
    bezeichnung: "Erneute Einsicht ins Führungszeugnis nach",
    wert: 5,
    einheit: "JAHRE",
    land: "DE",
    status: "EMPFEHLUNG",
    rechtsgrundlage: "Vereinbarungen nach § 72a Abs. 4 SGB VIII",
    quelle: "https://www.dsb.de/fileadmin/DSB.DE/PDF/PDF_2025/Leitfaden_Fuehrungszeugnisse_2025.pdf",
    geprueft: GEPRUEFT,
    hinweis:
      "Maßgeblich ist die Vereinbarung mit dem örtlichen Jugendamt. Die im selben Leitfaden genannte Löschfrist von 10 Jahren widerspricht § 72a Abs. 5 SGB VIII und wird nicht übernommen.",
  },
  {
    schluessel: RW.KINDERSCHUTZ_FZ_DIGITAL_AB_DATUM,
    bezeichnung: "Digitales Führungszeugnis über das BundID-Konto",
    wert: "2026-10-01",
    einheit: "DATUM",
    land: "DE",
    gueltigAb: "2026-10-01",
    status: "GILT",
    rechtsgrundlage: "§ 30d BZRG (G. v. 18.06.2026, BGBl. 2026 I Nr. 183)",
    quelle: `${GII}/bzrg/__30d.html`,
    geprueft: GEPRUEFT,
    hinweis:
      "Start am 01.10.2026 laut Presseberichten bestätigt. Echtheit per QR- oder Datamatrix-Code mit der App ZeSI mobile (Bundesdruckerei) prüfen; die Datei nicht speichern, nur den Vermerk. Ob die Gebührenbefreiung für Ehrenamtliche im digitalen Antrag geht, ist offen.",
  },
  // ── SEPA ──────────────────────────────────────────────────
  {
    schluessel: RW.SEPA_VORABANKUENDIGUNG_TAGE,
    bezeichnung: "Vorabankündigung (Pre-Notification) vor Fälligkeit, Kalendertage",
    wert: 14,
    einheit: "TAGE",
    land: "DE",
    status: "GILT",
    rechtsgrundlage: "SEPA-Basislastschrift-Regelwerk (EPC), Inkassovereinbarung der Bank",
    quelle: SEPA_FACTSHEET,
    geprueft: GEPRUEFT,
    hinweis: "Gilt ohne andere Vereinbarung; kürzer nur, wenn Mandat oder Beitragsordnung es vorsehen.",
  },
  {
    schluessel: RW.SEPA_RUECKGABE_AUTORISIERT_WOCHEN,
    bezeichnung: "Erstattung einer autorisierten Lastschrift verlangen innerhalb von",
    wert: 8,
    einheit: "WOCHEN",
    land: "DE",
    status: "GILT",
    rechtsgrundlage: "§ 675x Abs. 4 BGB",
    quelle: `${GII}/bgb/__675x.html`,
    geprueft: GEPRUEFT,
    hinweis: "Ab Belastung des Kontos, ohne Angabe von Gründen.",
  },
  {
    schluessel: RW.SEPA_RUECKGABE_OHNE_MANDAT_MONATE,
    bezeichnung: "Erstattung einer nicht autorisierten Lastschrift (kein Mandat) verlangen innerhalb von",
    wert: 13,
    einheit: "MONATE",
    land: "DE",
    status: "GILT",
    rechtsgrundlage: "§ 676b Abs. 2 BGB",
    quelle: `${GII}/bgb/__676b.html`,
    geprueft: GEPRUEFT,
    hinweis: "Ab dem Tag der Belastung. Deshalb den Nachweis jedes Mandats aufbewahren.",
  },
  {
    schluessel: RW.SEPA_MANDAT_VERFALL_MONATE,
    bezeichnung: "Mandat verfällt ohne Einzug nach",
    wert: 36,
    einheit: "MONATE",
    land: "DE",
    status: "GILT",
    rechtsgrundlage: "SEPA-Basislastschrift-Regelwerk (EPC)",
    quelle: SEPA_FACTSHEET,
    geprueft: GEPRUEFT,
    hinweis: "Frist beginnt mit jedem Einzug neu. Banken prüfen das nicht; der Verein muss es selbst sperren.",
  },
  {
    schluessel: RW.SEPA_MANDAT_AUFBEWAHRUNG_MONATE,
    bezeichnung: "Mandat nach Erlöschen mindestens aufbewahren ab letztem Einzug",
    wert: 14,
    einheit: "MONATE",
    land: "DE",
    status: "GILT",
    rechtsgrundlage: "SEPA-Basislastschrift-Regelwerk (EPC)",
    quelle: SEPA_FACTSHEET,
    geprueft: GEPRUEFT,
    hinweis: "Mindestfrist; längere Fristen aus § 147 AO gehen vor.",
  },
  {
    schluessel: RW.SEPA_EMPFAENGERPRUEFUNG_AB_DATUM,
    bezeichnung: "Empfängerüberprüfung (Verification of Payee) bei Überweisungen",
    wert: "2025-10-09",
    einheit: "DATUM",
    land: "DE",
    gueltigAb: "2025-10-09",
    status: "GILT",
    rechtsgrundlage: "Verordnung (EU) 2024/886",
    quelle:
      "https://legal.pwc.de/de/news/fachbeitraege/anforderungen-an-die-empfangeruberprufung-verification-of-payee-vop-nach-der-eu-verordnung-uber-echtzeituberweisungen-ipr",
    geprueft: GEPRUEFT,
    hinweis:
      "Kontoinhabername des Vereins exakt wie bei der Bank führen (Rechnungen, Zahlungslinks); Auszahlungen mit dem Namen des Kontoinhabers. Gilt nicht für Lastschriften.",
  },
  // ── Vereinsrecht und Barrierefreiheit ─────────────────────
  {
    schluessel: RW.VEREIN_SATZUNGSAENDERUNG_MEHRHEIT_PROZENT,
    bezeichnung: "Satzungsänderung: Mehrheit der abgegebenen Stimmen (drei Viertel)",
    wert: 75,
    einheit: "PROZENT",
    land: "DE",
    status: "GILT",
    rechtsgrundlage: "§ 33 Abs. 1 S. 1 BGB",
    quelle: `${GII}/bgb/__33.html`,
    geprueft: GEPRUEFT,
    hinweis: "Die Satzung kann anderes bestimmen (§ 40 BGB). Zweckänderung braucht die Zustimmung aller Mitglieder.",
  },
  {
    schluessel: RW.BFSG_AB_DATUM,
    bezeichnung: "Barrierefreiheit für Online-Dienste an Verbraucher (Shop, Tickets, Buchung)",
    wert: "2025-06-28",
    einheit: "DATUM",
    land: "DE",
    gueltigAb: "2025-06-28",
    status: "GILT",
    rechtsgrundlage: "Barrierefreiheitsstärkungsgesetz (BFSG)",
    quelle: "https://bsb.vibss.de/vereinsmanagement/recht/besondere-rechtsthemen/barrierefreiheitsstaerkungsgesetz/faq",
    geprueft: GEPRUEFT,
    hinweis:
      "Kleinstunternehmen (unter 10 Beschäftigte, höchstens 2 Mio. EUR Umsatz oder Bilanzsumme) sind bei Dienstleistungen ausgenommen. Mitgliedsantrag und Beitrag gelten laut BSB nicht als Verbrauchervertrag.",
  },
];

export const VORHABEN: readonly Vorhaben[] = [
  {
    id: "br-517-26",
    titel: "Bundesrats-Entschließung Bayern zur steuerlichen Entlastung von Vereinen (BR-Drs. 517/26)",
    status: "BUNDESRAT",
    stand:
      "Eingebracht am 09.09.2026, zugewiesen an den Finanzausschuss (federführend) und den Rechtsausschuss. Keine Ausschussempfehlung und kein Beschluss bekannt. Eine Entschließung bindet den Bundestag nicht.",
    betrifft: [
      RW.STEUER_FREIGRENZE_WGB_EUR,
      RW.STEUER_ZWECKBETRIEB_SPORT_EUR,
      RW.UST_PAUSCHALER_VORSTEUERABZUG_GRENZE_EUR,
      RW.STEUER_FREIBETRAG_KST_EUR,
      RW.STEUER_ZEITNAHE_MITTELVERWENDUNG_GRENZE_EUR,
    ],
    folgen:
      "Gefordert: Freigrenze 100.000 EUR mit Dreijahresdurchschnitt, Sportveranstaltungen und § 23a UStG je 100.000 EUR, Freibetrag 10.000 EUR, zeitnahe Mittelverwendung abschaffen, Einfachsteuererklärung. Erst bei einem Gesetzentwurf einplanen. Ein Dreijahresdurchschnitt bräuchte eine neue Berechnung im Grenzwächter.",
    quelle: "https://www.bundesrat.de/bv.html?id=0517-26",
    geprueft: GEPRUEFT,
    wiedervorlage: "2027-01-15",
  },
  {
    id: "jstg-2026",
    titel: "Jahressteuergesetz 2026 und Modernisierung des Gemeinnützigkeitsrechts",
    status: "PARLAMENT",
    stand:
      "Referentenentwurf 19.05.2026, Kabinett 12.08.2026, Abschluss im Bundestag bis Ende 2026 geplant. In den ausgewerteten Zusammenfassungen keine Änderungen für Vereine, Spenden oder Pauschalen; die Zivilgesellschaft kritisiert genau das. „Gemeinnützigkeitsrecht III“ ist kein eigener Entwurf, sondern ein Lobbyregister-Eintrag mit Forderungen zum Zweckkatalog (§ 52 AO), der auf den JStG-Entwurf verweist.",
    betrifft: [],
    folgen: "Nach Verkündung den Gesetzestext auf Änderungen in AO, EStG und UStG mit Vereinsbezug prüfen.",
    quelle:
      "https://www.ey.com/de_de/technical/steuernachrichten/kabinett-verabschiedet-regierungsentwurf-des-jahressteuergesetzes-2026",
    geprueft: GEPRUEFT,
    wiedervorlage: "2027-01-15",
  },
  {
    id: "kassenpflicht-2028",
    titel: "Registrierkassenpflicht und digitale Belegbereitstellung ab 2028",
    status: "KABINETT",
    stand:
      "Kabinettsentwurf vom 23.09.2026: elektronische Kasse ab 01.01.2028 bei mehr als 100.000 EUR Jahresumsatz, befreit unter 12.000 EUR Barumsatz im Jahr. Statt Papierbon digitale Belegbereitstellung. Weitere Ausnahmen per Rechtsverordnung (genannt: Vertrauenskassen, Direktvermarktung, Wochen- und Jahrmärkte); Vereinsfeste sind nicht ausdrücklich genannt. Bundestag und Bundesrat stehen aus.",
    betrifft: [RW.KASSE_TSE_MELDEFRIST_MONATE],
    folgen:
      "Kassenbuch und Festkassen so bauen, dass Bar- und Gesamtumsatz je Jahr auswertbar sind. Nach Verkündung die Grenzwerte als Rechtswerte anlegen.",
    quelle: "https://www.deutsche-handwerks-zeitung.de/?p=384034",
    geprueft: GEPRUEFT,
    wiedervorlage: "2027-01-15",
  },
  {
    id: "zer-spendenkonten",
    titel: "Zuwendungsempfängerregister: Spendenkonten selbst eintragen, digitale Zuwendungsbestätigung",
    status: "ANGEKUENDIGT",
    stand:
      "Das Register läuft seit 01.01.2024 beim BZSt, die Daten kommen von den Finanzämtern. Der Selbsteintrag von Spendenkonten und Website ist angekündigt, aber ohne Termin und nicht live. Eine digitale Spendenquittung über das Register ist nicht gestartet. Die elektronische Übermittlung nach § 50 Abs. 2 EStDV (Vollmacht und IdNr. des Spenders) ist möglich, wird aber kaum genutzt.",
    betrifft: [],
    folgen:
      "Das amtliche Muster bleibt der Regelfall. Datenmodell für eine Übermittlung nach § 93c AO (verschlüsselte IdNr., Vollmacht) vorhalten. Sobald der Selbsteintrag möglich ist: Hinweis im Fristenradar.",
    quelle: "https://www.roedl.com/insights/zuwendungsempfaengerregister-webseite-bundeszentralamt-steuern/",
    geprueft: GEPRUEFT,
    wiedervorlage: "2027-01-15",
  },
  {
    id: "fz-papier-behoerden",
    titel: "Digitales Führungszeugnis: Ende des Papierversands an Behörden",
    status: "ANGEKUENDIGT",
    stand:
      "Das digitale Führungszeugnis läuft seit 01.10.2026 (Rechtswert kinderschutz.fz_digital_ab). Der Bundestag hat die Regierung gebeten, bis 31.03.2027 zu entscheiden, ob und wann der Papierversand an Behörden endet.",
    betrifft: [RW.KINDERSCHUTZ_FZ_DIGITAL_AB_DATUM],
    folgen:
      "Für Vereine ohne direkte Folge. Klären, ob die Gebührenbefreiung für Ehrenamtliche im digitalen Antrag möglich ist; davon hängt das Bestätigungsschreiben des Vereins ab.",
    quelle: "https://www.it-daily.net/shortnews/fuhrungszeugnis-wird-digital",
    geprueft: GEPRUEFT,
    wiedervorlage: "2027-04-15",
  },
  {
    id: "digital-omnibus-dsgvo",
    titel: "Digital Omnibus der EU: Änderungen an DSGVO und Cookie-Regeln",
    status: "VERHANDLUNG",
    stand:
      "Der Teil zur KI-Verordnung ist laut Berichten beschlossen. Der DSGVO- und Cookie-Teil ist weiter in Verhandlung zwischen Parlament und Rat. Änderungen vor 2027 sind nicht absehbar.",
    betrifft: [RW.DSGVO_DSB_SCHWELLE_PERSONEN, RW.DSGVO_AUSKUNFT_FRIST_MONATE, RW.DSGVO_PANNE_MELDEFRIST_STUNDEN],
    folgen:
      "Keine Anpassung, solange nichts beschlossen ist. Bei einer Einigung Einwilligungs- und Cookie-Texte sowie die Meldefristen prüfen.",
    quelle: "https://www.heuking.de/de/news-events/newsletter-fachbeitraege/artikel/neue-entwicklungen-im-digital-omnibus.html",
    geprueft: GEPRUEFT,
    wiedervorlage: "2027-04-15",
  },
  {
    id: "eugh-c-703-25-p",
    titel: "EuGH C-703/25 P (Latombe): Rechtsmittel gegen das EU-US Data Privacy Framework",
    status: "ANHAENGIG",
    stand:
      "Rechtsmittel eingelegt am 31.10.2025 gegen das EuG-Urteil T-553/23 vom 03.09.2025. Kein Verhandlungs- oder Urteilstermin bekannt. Das Rechtsmittel hat keine aufschiebende Wirkung, der Angemessenheitsbeschluss gilt weiter.",
    betrifft: [],
    folgen:
      "Unterauftragnehmer mit US-Bezug (Zahlungsdienst, Mailversand, KI) zusätzlich auf Standardvertragsklauseln stützen. Das Kern-Hosting bleibt in Deutschland.",
    quelle: "https://eur-lex.europa.eu/eli/C/2025/6610/oj",
    geprueft: GEPRUEFT,
    wiedervorlage: "2027-01-15",
  },
  {
    id: "epc-strukturierte-adressen",
    titel: "SEPA: Wegfall unstrukturierter Adressangaben",
    status: "VERSCHOBEN",
    stand:
      "Ursprünglich ab 15.11.2026. Das EPC-Gremium PSMB hat am 09.09.2026 die Verschiebung beschlossen. Die Technischen Spezifikationen SCT/SCL und SDD/SCL treten nicht in Kraft, die Fassungen vom 05.10.2025 gelten über den 15.11.2026 hinaus. Ein neuer Termin steht nicht fest.",
    betrifft: [],
    folgen:
      "SEPA-Dateien dürfen weiter hybride Adressen tragen (Pflicht: Ort und Ländercode). Trotzdem strukturiert vorbereiten: Straße und Hausnummer getrennt speichern, damit der spätere Umstieg keine Datenpflege braucht.",
    quelle:
      "https://www.bundesbank.de/de/aufgaben/unbarer-zahlungsverkehr/emz/sepa-clearer/teilnahme/verfahrensregeln-fuer-die-abwicklung-von-sepa-zahlungen-ueber-den-sepa-clearer-des-emz-gueltig-ab-15-november-2026-602798",
    geprueft: GEPRUEFT,
    wiedervorlage: "2027-01-15",
  },
  {
    id: "bmf-faq-erechnung",
    titel: "BMF-FAQ zur E-Rechnung",
    status: "ANGEKUENDIGT",
    stand:
      "Letzter bekannter Stand 23.03.2026: Fragen 7a und 7b zu Pflichtinhalten und Verweisen auf andere Dokumente überarbeitet und strenger ausgelegt. Daneben gelten die BMF-Schreiben vom 15.10.2024 und 15.10.2025. Die FAQ-Seite war am 23.10.2026 nicht erreichbar (HTTP 503). Keine vereinsspezifischen Neuerungen gefunden.",
    betrifft: [RW.ERECHNUNG_UEBERGANG_2027_GRENZE_EUR, RW.ERECHNUNG_VERSAND_PFLICHT_ALLE_AB_DATUM],
    folgen: "Vor dem Bau des Rechnungsausgangs die Fragen 7a und 7b gegen die Pflichtangaben im Rechnungsmodell prüfen.",
    quelle: "https://www.bundesfinanzministerium.de/Content/DE/FAQ/e-rechnung.html",
    geprueft: GEPRUEFT,
    wiedervorlage: "2027-01-15",
  },
];

/** Heute als ISO-Datum (JJJJ-MM-TT), in Ortszeit. */
function heute(): string {
  const d = new Date();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const tt = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${tt}`;
}

/**
 * Der Rechtswert, der am `stichtag` gilt (Vorgabe: heute). ISO-Daten
 * vergleichen sich als Zeichenketten richtig. `undefined`, wenn es fuer
 * den Tag keinen Wert gibt — dann nicht raten.
 */
export function rechtswert(
  schluessel: RwSchluessel,
  stichtag: string = heute(),
  land: Land = "DE",
): Rechtswert | undefined {
  return RECHTSWERTE.find(
    (r) =>
      r.schluessel === schluessel &&
      r.land === land &&
      (r.gueltigAb === undefined || r.gueltigAb <= stichtag) &&
      (r.gueltigBis === undefined || stichtag <= r.gueltigBis),
  );
}

/** Die Zahl zum Stichtag; wirft, wenn es keine gibt oder der Wert ein Datum ist. */
export function wert(schluessel: RwSchluessel, stichtag: string = heute(), land: Land = "DE"): number {
  const r = rechtswert(schluessel, stichtag, land);
  if (!r || typeof r.wert !== "number") {
    throw new Error(`Kein Zahlenwert „${schluessel}“ für ${land} am ${stichtag}`);
  }
  return r.wert;
}

/** Das Datum (ISO) zum Stichtag, fuer Werte mit Einheit DATUM. */
export function datum(schluessel: RwSchluessel, stichtag: string = heute(), land: Land = "DE"): string {
  const r = rechtswert(schluessel, stichtag, land) ?? RECHTSWERTE.find((x) => x.schluessel === schluessel && x.land === land);
  if (!r || r.einheit !== "DATUM" || typeof r.wert !== "string") {
    throw new Error(`Kein Datumswert „${schluessel}“ für ${land}`);
  }
  return r.wert;
}

/** Ist der Stichtag am oder nach dem Datum des Rechtswerts? (z. B. „gilt die E-Rechnungspflicht schon?“) */
export function giltAb(schluessel: RwSchluessel, stichtag: string = heute(), land: Land = "DE"): boolean {
  return datum(schluessel, stichtag, land) <= stichtag;
}

/** Vorhaben, deren Wiedervorlage am `stichtag` erreicht ist. */
export function faelligeVorhaben(stichtag: string = heute()): Vorhaben[] {
  return VORHABEN.filter((v) => v.wiedervorlage <= stichtag);
}
